// `AppErrorEvent.error` is typed Error, and half of what a catch block receives is not one — a rejected
// fetch, a thrown string, an oidc-client-ts object. A real Error passes through untouched (its stack is the
// point); anything else becomes one carrying the best string the value can give.
export function asError(value: unknown): Error {
  if (value instanceof Error) return value;
  if (typeof value === "string") return new Error(value);

  try {
    const message = (value as { message?: unknown } | null)?.message;
    if (typeof message === "string" && message.length > 0) return new Error(message);
  } catch {
    // A throwing `message` getter (or a hostile proxy) must not turn a reported failure into a new one.
  }

  try {
    // JSON.stringify returns undefined for undefined, a function, or a symbol — `new Error(undefined)` then
    // has an empty message, which is the exact thing this helper exists to prevent. Cap the length too: the
    // next catch site to use this could be holding a whole API response body.
    return new Error(JSON.stringify(value)?.slice(0, 500) ?? String(value));
  } catch {
    return new Error(String(value));
  }
}
